<script lang="ts">
  // external
  import { page } from "@roxi/routify";

  // components
  import AddLiquorLicenseModal from "@shared/svelte/Components/AddLiquorLicenseModal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // stores
  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
  import DemoSignupModal from "@shared/svelte/Components/Layout/DemoHeader/DemoSignupModal.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  export let showLiquorLicenseInfoBar: boolean;

  const boldText = "Looking for prices?";
  const hasLiquorLicense = !!$CurrentRetailerStore?.liquor_license;

  let buttonText: string;
  let mainText: string;
  let showAddLiquorLicenseModal = false;

  const toggleAddLiquorLicenseModal = (): void => {
    if ($page.path === "/demo/storefront/:distributorId") {
      return window["svelteModal"](DemoSignupModal, {});
    }

    showAddLiquorLicenseModal = !showAddLiquorLicenseModal;
  };

  $: if (!$CurrentRetailerStore?.has_satisfied_liquor_license_requirements && hasLiquorLicense) {
    buttonText = "Confirm liquor license";
    mainText = `Please confirm that your liquor license is correct to see wholesale
      pricing from your distributors, as well as to send orders to your reps.`;
  } else {
    buttonText = "Add liquor license";
    mainText = `A liquor license is required to see wholesale pricing from your distributors,
      as well as to send orders to your reps.`;
  }
</script>

<AddLiquorLicenseModal bind:showAddLiquorLicenseModal />
{#if !$CurrentRetailerStore?.has_satisfied_liquor_license_requirements && showLiquorLicenseInfoBar}
  <div class="fizz-styles" style="position:sticky; top:0px; z-index:10;">
    <div class="fizz-surface-yellow">
      {#if $LayoutStore.isDesktop}
        <div
          class="fizz-container fizz-space-between fizz-inset-squish-32"
          data-testid="liquor-license-info-bar"
        >
          <span class="fizz-text-small fizz-flex-row">
            <span class="fizz-text-warning">
              <Icon type="Warning" height="24" width="24" />
            </span>
            <span class="fizz-text-left">
              <span class="fizz-text-strong fizz-inline-4">{boldText}</span>
              {mainText}
            </span>
          </span>
          <button class="fizz-button fizz-button-small" on:click={toggleAddLiquorLicenseModal}>
            {buttonText}
          </button>
        </div>
      {:else}
        <div
          class="fizz-inset-squish-24 fizz-flex-row-inline-4 fizz-align-content-start"
          data-testid="liquor-license-info-bar"
        >
          <span class="fizz-text-warning fizz-inline-8">
            <Icon type="Warning" height="24" width="24" />
          </span>
          <span>
            <div class="fizz-stack-8 fizz-text-left">
              <span class="fizz-text-strong fizz-inline-4">{boldText}</span>
              {mainText}
            </div>
            <button class="fizz-button fizz-button-small" on:click={toggleAddLiquorLicenseModal}>
              {buttonText}
            </button>
          </span>
        </div>
      {/if}
    </div>
  </div>
{/if}
